import uniqBy from 'lodash.uniqby'

const initialState = {
  isFetching: false,
  isFetched: false,
  isError: false,
  untrustedDevice: false,
  data: {
    phones: [
      {
        areaCode: '',
        countryCode: '',
        phoneNumber: '',
        type: 'Cellphone'
      },
      {
        areaCode: '',
        countryCode: '',
        phoneNumber: '',
        type: 'Residential'
      }
    ]
  }
}

const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR'
const UPDATE_PERSONAL_INFO_REQUEST = 'UPDATE_PERSONAL_INFO_REQUEST'
const UPDATE_PERSONAL_INFO_REQUEST_SUCCESS = 'UPDATE_ PERSONAL_INFO_REQUEST_SUCCESS'
const UPDATE_PERSONAL_INFO_REQUEST_ERROR = 'UPDATE_PERSONAL_INFO_REQUEST_ERROR'
const PERSONAL_INFO_REQUEST = 'PERSONAL_INFO_REQUEST'
const PERSONAL_INFO_REQUEST_SUCCESS = 'PERSONAL_INFO_REQUEST_SUCCESS'
const PERSONAL_INFO_REQUEST_ERROR = 'PERSONAL_INFO_REQUEST_ERROR'
const UPDATE_PERSONAL_INFO_REQUEST_ERROR_UNTRUSTED = 'UPDATE_PERSONAL_INFO_REQUEST_ERROR_UNTRUSTED'
const SET_UNTRUSTED_DEVICE_INITIAL_STATE = 'SET_UNTRUSTED_DEVICE_INITIAL_STATE'

export const ACTION_TYPES = {
  UPDATE_USER_AVATAR,
  UPDATE_PERSONAL_INFO_REQUEST,
  UPDATE_PERSONAL_INFO_REQUEST_SUCCESS,
  UPDATE_PERSONAL_INFO_REQUEST_ERROR,
  UPDATE_PERSONAL_INFO_REQUEST_ERROR_UNTRUSTED,
  PERSONAL_INFO_REQUEST,
  PERSONAL_INFO_REQUEST_SUCCESS,
  PERSONAL_INFO_REQUEST_ERROR,
  SET_UNTRUSTED_DEVICE_INITIAL_STATE
}

const handlePersonalInfoRequestSuccess = (state, payload) => {
  const uniquePhones = [
    ...payload.data.personalInfo.phones,
    ...state.data.phones
  ]

  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    data: {
      ...payload.data.personalInfo,
      phones: uniqBy(uniquePhones, 'type')
    }
  }

  return newState
}

export const getPersonalInfo = (type, text) => ({
  type: PERSONAL_INFO_REQUEST,
  payload: { type, text }
})

export const loadAvatar = () => ({
  type: UPDATE_USER_AVATAR
})

export const patchPersonalInfo = payload => ({
  type: UPDATE_PERSONAL_INFO_REQUEST,
  payload
})

const personalInfo = (state = initialState, { type, payload }) => {
  switch (type) {
    case PERSONAL_INFO_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case PERSONAL_INFO_REQUEST_SUCCESS:
      return handlePersonalInfoRequestSuccess(state, payload)
    case PERSONAL_INFO_REQUEST_ERROR:
      return {
        ...state,
        isFetched: true
      }
    case UPDATE_PERSONAL_INFO_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case UPDATE_PERSONAL_INFO_REQUEST_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isError: false
      }
    case UPDATE_PERSONAL_INFO_REQUEST_ERROR_UNTRUSTED:
      return {
        ...state,
        untrustedDevice: true
      }
    default:
      return state
  }
}

export default personalInfo
